module.exports = __webpack_public_path__ + "img/sc.fc8b1936.svg";